import Head from "next/head";
import Script from "next/script";
import { getWsrvUrl } from "@/utils/wsrv";

export default function Favicon({ favicon, scripts }) {
  const optimizedFavicon = favicon;
  return (
    <>
      {optimizedFavicon && (
        <Head>
          <meta name="msapplication-square" content={optimizedFavicon} />
          <link rel="icon" type="image/webp" href={optimizedFavicon} />
          <link rel="apple-touch-icon" href={optimizedFavicon} />
        </Head>
      )}
      {scripts?.length > 0 &&
        scripts.map((scriptItem, index) => (
          <Script
            strategy="afterInteractive"
            key={index}
            {...scriptItem.attributes}
            dangerouslySetInnerHTML={{ __html: scriptItem?.innerHTML || null }}
          />
        ))}
    </>
  );
}
